import type { ComponentProps } from 'react';

const CostOfAilment = (props: ComponentProps<'svg'>) => {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="5.25"
        y="3.5"
        width="42.4423"
        height="46.422"
        rx="4.68318"
        fill="#85CFC9"
      />
      <rect
        x="7.90234"
        y="6.15268"
        width="37.137"
        height="13.2634"
        rx="2.34159"
        fill="#41797A"
      />
      <rect
        x="7.90234"
        y="22.0688"
        width="37.137"
        height="23.8742"
        rx="2.34159"
        fill="#98E4D9"
      />
      <rect
        x="10.2285"
        y="23.9989"
        width="9.36629"
        height="4.68323"
        fill="#5CB0AB"
      />
      <rect
        x="10.2285"
        y="31.0238"
        width="9.36629"
        height="4.68323"
        fill="#5CB0AB"
      />
      <rect
        x="10.2285"
        y="37.985"
        width="21.0741"
        height="4.68323"
        fill="#5CB0AB"
      />
      <rect
        x="21.9346"
        y="23.9989"
        width="9.36629"
        height="4.68323"
        fill="#5CB0AB"
      />
      <rect
        x="21.9346"
        y="31.0238"
        width="9.36629"
        height="4.68323"
        fill="#5CB0AB"
      />
      <rect
        x="33.6436"
        y="23.9989"
        width="9.36629"
        height="4.68323"
        fill="#5CB0AB"
      />
      <rect
        x="33.6436"
        y="31.0237"
        width="9.36629"
        height="4.68323"
        fill="#5CB0AB"
      />
      <rect
        x="33.6436"
        y="37.9849"
        width="9.36629"
        height="4.68323"
        fill="#5CB0AB"
      />
      <path
        d="M39.1739 16.0633L39.2839 13.4899L37.2236 14.8864L36.5928 13.7278L38.7804 12.5509L36.5928 11.374L37.2236 10.2153L39.2839 11.6118L39.1739 9.03844H40.4298L40.3198 11.6118L42.3801 10.2153L43.011 11.374L40.8233 12.5509L43.011 13.7278L42.3801 14.8864L40.3198 13.4899L40.4298 16.0633H39.1739Z"
        fill="#BFF3EA"
      />
      <path
        d="M30.6749 16.0633L30.7849 13.4899L28.7246 14.8864L28.0938 13.7278L30.2814 12.5509L28.0938 11.374L28.7246 10.2153L30.7849 11.6118L30.6749 9.03844H31.9308L31.8208 11.6118L33.8811 10.2153L34.5119 11.374L32.3243 12.5509L34.5119 13.7278L33.8811 14.8864L31.8208 13.4899L31.9308 16.0633H30.6749Z"
        fill="#BFF3EA"
      />
      <path
        d="M22.1749 16.0633L22.2849 13.49L20.2246 14.8864L19.5938 13.7278L21.7814 12.5509L19.5938 11.374L20.2246 10.2154L22.2849 11.6118L22.1749 9.03845H23.4308L23.3208 11.6118L25.3811 10.2154L26.0119 11.374L23.8243 12.5509L26.0119 13.7278L25.3811 14.8864L23.3208 13.49L23.4308 16.0633H22.1749Z"
        fill="#BFF3EA"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M42.6517 48.664V45.0023H44.4251L46.8122 48.4146L43.8131 52.0309H45.829L47.8904 49.274L49.9669 52.0309H51.9828L48.8756 48.2843L51.7555 44.8205H49.7395L47.926 47.2747L46.1833 44.8185C46.5553 44.7425 46.8926 44.6263 47.191 44.4728C47.4585 44.3352 47.6947 44.1677 47.8968 43.9723C47.9374 43.9331 47.9766 43.8927 48.0144 43.8513C48.0313 43.8328 48.0479 43.814 48.0642 43.7951C48.1015 43.7518 48.1373 43.7074 48.1716 43.6618C48.2759 43.5233 48.3664 43.3744 48.4424 43.2156C48.475 43.1475 48.5049 43.0776 48.5322 43.0059C48.5856 42.865 48.6286 42.7172 48.6607 42.5628C48.7028 42.3597 48.726 42.1453 48.7293 41.9202C48.7296 41.9014 48.7297 41.8826 48.7297 41.8636C48.7297 41.6988 48.7192 41.5393 48.6984 41.3853C48.4808 39.7692 47.1414 38.7674 45.1071 38.7674H41.0602V48.664H42.6517ZM52.1488 41.3853C52.0356 39.7117 51.3242 38.1402 49.9888 36.9963C48.5853 35.7939 46.8125 35.3322 45.1071 35.3322H40.2777C38.8126 35.3322 37.625 36.5198 37.625 37.9849V52.0992L37.6255 52.5H47.5505H47.9012H48.2546H52.5773L52.3608 48.287V41.3853H52.1488ZM42.6517 43.7016H44.9101C45.2969 43.7016 45.637 43.6547 45.9268 43.5628C45.9711 43.5487 46.0143 43.5336 46.0563 43.5174C46.0666 43.5134 46.0767 43.5094 46.0868 43.5054C46.5158 43.3324 46.8168 43.047 46.976 42.656C47.0632 42.442 47.1079 42.1963 47.1079 41.9202C47.1079 41.9012 47.1077 41.8823 47.1072 41.8636C47.1032 41.6919 47.0804 41.5323 47.0396 41.3853C46.9067 40.9062 46.582 40.5604 46.0868 40.3623C45.8117 40.2523 45.4839 40.1878 45.1071 40.1713C45.0429 40.1685 44.9772 40.1671 44.9101 40.1671H42.6517V43.7016Z"
        fill="white"
      />
      <path
        d="M43.8144 52.0308L46.9217 48.2843L44.5026 44.8205H46.0577L47.8917 47.3229L49.7409 44.8205H51.7568L48.8769 48.2843L51.9842 52.0308H49.9683L47.8917 49.2739L45.8303 52.0308H43.8144Z"
        fill="#CCC4BA"
      />
      <path
        d="M48.913 48.664H46.988L44.4264 45.0022H42.653V48.664H41.0615V38.7674H45.1085C47.3366 38.7674 48.7311 39.9691 48.7311 41.8636C48.7311 43.4329 47.7762 44.4933 46.1847 44.8184L48.913 48.664ZM42.653 40.1671V43.7015H44.9115C46.3211 43.7015 47.1093 43.0795 47.1093 41.9202C47.1093 40.7891 46.3211 40.1671 44.9115 40.1671H42.653Z"
        fill="#CCC4BA"
      />
    </svg>
  );
};

export default CostOfAilment;
